import * as React from 'react';
//STYLES
import styles from '../module_css/formsCatalogs.module.css';
//CUSTOM COMPONENTS
import CustomBackdrop from '../components/CustomBackdrop';
import noImage from '../assets/svg/404.svg';

export default function PreviewPhoto({ id = null }) {
  const [openBackdrop, setOpenBackdrop] = React.useState(true);
  const [imgSrc, setImgSrc] = React.useState(id || noImage);

  const handleImageLoad = () => {
    setOpenBackdrop(false);
  };

  const handleImageError = () => {
    setImgSrc(noImage);
    setOpenBackdrop(false);
  };

  React.useEffect(() => {
    setImgSrc(id || noImage);
    setOpenBackdrop(true);
  }, [id]);

  return (
    <>
      <CustomBackdrop open={openBackdrop}/>
      <div className={styles.container_main_form}>
        <img
          src={imgSrc}
          alt="Preview"
          className={styles.logo_form}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ width: 200, height: 200 }}
        />
      </div>
    </>
  );
}